import { render, staticRenderFns } from "./SubdistributorDetail.vue?vue&type=template&id=7df9ec5a&scoped=true"
import script from "./SubdistributorDetail.vue?vue&type=script&lang=js"
export * from "./SubdistributorDetail.vue?vue&type=script&lang=js"
import style0 from "./SubdistributorDetail.vue?vue&type=style&index=0&id=7df9ec5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df9ec5a",
  null
  
)

export default component.exports